(function () {
  'use strict';
  document.documentElement.classList.add('js');

  /* ---------- Scroll reveals ---------- */
  var revealSel = '[data-reveal], .drop__head, .archive__head, .manifesto__text, .story__body, .next__row, .related__title, .page-head, .edition, .lookbook';
  var targets = document.querySelectorAll(revealSel);
  targets.forEach(function (el) {
    if (!el.classList.contains('edition') && !el.classList.contains('lookbook')) el.setAttribute('data-reveal', '');
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });
  } else {
    targets.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Product form: variant picking ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var button = root.querySelector('[data-add]');
    var buttonLabel = root.querySelector('[data-add-label]');
    var selectedLabels = root.querySelectorAll('[data-selected-label]');
    var fieldsets = root.querySelectorAll('[data-option-index]');

    var lockAt = button && button.getAttribute('data-locked-until') ? new Date(button.getAttribute('data-locked-until')).getTime() : NaN;
    function isLocked() { return !isNaN(lockAt) && Date.now() < lockAt; }
    if (isLocked()) {
      var unlockTimer = setInterval(function () { if (!isLocked()) { clearInterval(unlockTimer); update(); } }, 1000);
    }

    function selected() {
      var out = [];
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        out[Number(fs.getAttribute('data-option-index'))] = c ? c.value : null;
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok && opts.indexOf(null) === -1) return v;
      }
      return null;
    }

    function markAvailability(opts) {
      fieldsets.forEach(function (fs) {
        var idx = Number(fs.getAttribute('data-option-index'));
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var match = variants.some(function (v) {
            return test.every(function (val, k) { return val === null || v.options[k] === val; }) && v.available;
          });
          input.closest('.pill').classList.toggle('is-unavailable', !match);
        });
      });
    }

    function update() {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      fieldsets.forEach(function (fs, i) {
        if (selectedLabels[i]) selectedLabels[i].textContent = opts[Number(fs.getAttribute('data-option-index'))] || '—';
      });
      if (!v) {
        if (button) button.disabled = true;
        if (buttonLabel) buttonLabel.textContent = data.labels.choose;
        if (idInput) idInput.value = '';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl && data.prices[v.id]) priceEl.textContent = data.prices[v.id];
      if (compareEl) compareEl.hidden = true;
      var locked = isLocked();
      if (button) button.disabled = !v.available || locked;
      if (buttonLabel) buttonLabel.textContent = locked ? data.labels.locked : (v.available ? data.labels.add + ' — ' + (data.prices[v.id] || '') : data.labels.soldout);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.featured_media) {
        var target = document.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        var gallery = target && target.parentElement;
        if (target && gallery && gallery.scrollWidth > gallery.clientWidth) {
          gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
    update();
  });

  /* ---------- Hero video: load only the visible version, autoplay, quiet retry on first touch ---------- */
  document.querySelectorAll('[data-hero-video]').forEach(function (hero) {
    var desk = hero.querySelector('.hv__vid--desk');
    var mob = hero.querySelector('.hv__vid--mob');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = null;
    function pick() {
      var wide = window.matchMedia('(min-width: 750px)').matches;
      return wide ? (desk || mob) : (mob || desk);
    }
    function tryPlay() {
      if (!current) return;
      current.muted = true;
      current.defaultMuted = true;
      var p = current.play();
      if (p && p.catch) p.catch(function () {});
    }
    function start() {
      var v = pick();
      if (!v || v === current) return;
      if (current) current.pause();
      current = v;
      v.muted = true;
      v.setAttribute('muted', '');
      if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); v.preload = 'auto'; v.load(); }
      if (reduce) return;
      tryPlay();
      v.addEventListener('canplay', function once() { v.removeEventListener('canplay', once); tryPlay(); });
    }
    start();
    /* Phones in Low Power Mode block autoplay until the first touch; start quietly then. */
    ['touchend', 'click', 'keydown'].forEach(function (ev) {
      document.addEventListener(ev, function () { if (current && current.paused && !reduce) tryPlay(); }, { passive: true });
    });
    window.addEventListener('resize', function () { clearTimeout(hero._t); hero._t = setTimeout(start, 250); });
    document.addEventListener('visibilitychange', function () {
      if (!current) return;
      if (document.hidden) current.pause(); else tryPlay();
    });
  });

  /* ---------- Moving sunburst: fades in, then turns with scroll ---------- */
  (function () {
    var rays = Array.prototype.slice.call(document.querySelectorAll('[data-rays]'));
    if (!rays.length) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); seen.unobserve(e.target); } });
      }, { threshold: 0.15 });
      rays.forEach(function (r) { seen.observe(r); });
    } else { rays.forEach(function (r) { r.classList.add('is-in'); }); }
    if (still) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      rays.forEach(function (r) {
        var b = r.getBoundingClientRect();
        if (b.bottom < -200 || b.top > vh + 200) return;
        var p = (vh - b.top) / (vh + b.height);          // 0 entering, 1 leaving
        p = Math.max(0, Math.min(1, p));
        r.style.setProperty('--ray-rot', (-16 + p * 26).toFixed(2) + 'deg');
        r.style.setProperty('--ray-scale', (0.9 + p * 0.2).toFixed(3));
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  /* ---------- Footer logo impact ---------- */
  document.querySelectorAll('[data-impact]').forEach(function (el) {
    function hit() { el.classList.add('is-hit'); }
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.classList.add('is-hit'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { hit(); io.disconnect(); } });
    }, { threshold: 0.55 });
    io.observe(el);
  });

  /* ---------- Archive full-screen viewer ---------- */
  document.querySelectorAll('[data-lightbox]').forEach(function (dlg) {
    var section = dlg.closest('section');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-lightbox-open]')).filter(function (c) { return c.getAttribute('data-full'); });
    var img = dlg.querySelector('[data-lightbox-img]');
    var cap = dlg.querySelector('[data-lightbox-caption]');
    var count = dlg.querySelector('[data-lightbox-count]');
    var idx = 0, lastFocus = null;
    function show(i) {
      idx = (i + cards.length) % cards.length;
      var c = cards[idx];
      img.src = c.getAttribute('data-full');
      img.alt = c.querySelector('img') ? c.querySelector('img').alt : '';
      cap.textContent = c.getAttribute('data-caption');
      count.textContent = (idx + 1) + ' / ' + cards.length;
    }
    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    }
    dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); });
    cards.forEach(function (c, i) { c.addEventListener('click', function () { open(i); }); });
    dlg.querySelector('[data-lightbox-close]').addEventListener('click', close);
    dlg.querySelector('[data-lightbox-prev]').addEventListener('click', function () { show(idx - 1); });
    dlg.querySelector('[data-lightbox-next]').addEventListener('click', function () { show(idx + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('lightbox__stage')) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
    });
    var sx = null, sy = null;
    dlg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
      sx = sy = null;
    }, { passive: true });
  });

  /* ---------- Instagram handle fills in when it scrolls into view ---------- */
  document.querySelectorAll('.igf').forEach(function (el) {
    if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { setTimeout(function () { el.classList.add('is-in'); }, 350); io.disconnect(); } });
    }, { threshold: 0.6 });
    io.observe(el);
  });

  /* ---------- Mobile menu closes after a jump link ---------- */
  document.querySelectorAll('.menu-toggle .menu-panel a').forEach(function (a) {
    a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.open = false; });
  });

  /* ---------- Sticky Shop bar: shows after the hero, hides while the buy box is on screen ---------- */
  document.querySelectorAll('[data-stickybar]').forEach(function (bar) {
    var hero = document.querySelector('.hv, .hero');
    var buy = document.querySelector('#shop');
    var pastHero = false, buyVisible = false;
    function sync() { var show = pastHero && !buyVisible; bar.classList.toggle('is-shown', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); bar.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = show ? 0 : -1; }); }
    if (!('IntersectionObserver' in window)) { pastHero = true; sync(); return; }
    if (hero) new IntersectionObserver(function (es) { pastHero = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; sync(); }).observe(hero);
    else pastHero = true;
    if (buy) new IntersectionObserver(function (es) { buyVisible = es[0].isIntersecting; sync(); }, { threshold: 0.25 }).observe(buy);
    sync();
  });

  /* ---------- Drop countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var raw = el.getAttribute('data-countdown');
    var target = raw ? new Date(raw).getTime() : NaN;
    if (isNaN(target)) return;
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
        m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var sec = Math.floor(diff / 1000);
      if (d) d.textContent = pad(Math.floor(sec / 86400));
      if (h) h.textContent = pad(Math.floor((sec % 86400) / 3600));
      if (m) m.textContent = pad(Math.floor((sec % 3600) / 60));
      if (s) s.textContent = pad(sec % 60);
      if (diff <= 0) { clearInterval(timer); el.classList.add('is-live'); }
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- Cart: auto-submit quantity changes ---------- */
  document.querySelectorAll('[data-cart-form] .qty').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });
})();
